import { GenerateTrainingReportPdfInput, GeneratedDocumentPdf, GeneratedDocumentStatusEnum, ReportInput } from '@/models/gen/graphql';

import { GenerateTrainingReportPdfDocument } from '@/api/queries';
import { TIMEZONE_OFFSET_MINUTES } from '@/api/services/reports/reportQuery';
import downloadTrainingReportPDF from '@/pages/Reports/api/services/downloadTrainingReportPDF';
import graphApi from '@/api';
import searchGeneratedDocuments from '@/api/services/pdf/searchGeneratedDocuments';
import { sleep } from '@/utils';
import useSession from '@/state/session';

const [, runRefetchGenerateTrainingReportPDF] = graphApi(GenerateTrainingReportPdfDocument);

const generateTrainingReportPDF = async (input: GenerateTrainingReportPdfInput): Promise<GeneratedDocumentPdf> => {
  const res = await runRefetchGenerateTrainingReportPDF({ input });
  return res?.generateTrainingReportPDF?.generatedDocument;
};

export const generateAndDownloadTrainingReportPDF = async (query: Partial<ReportInput>): Promise<void> => {
  const input = {
    startDatetime: Array.isArray(query?.startDatetime) ? query?.startDatetime[0] : query?.startDatetime,
    endDatetime: Array.isArray(query?.endDatetime) ? query?.endDatetime[0] : query?.endDatetime,
    airports: query?.airports?.length ? query.airports : null,
    drivers: query?.drivers?.length ? query.drivers : null,
    roleIds: query?.roleIds?.length ? query.roleIds : [useSession.getState().state.config?.driverRoleId].filter(Boolean),
    userSessionTimezone: query?.userSessionTimezone || TIMEZONE_OFFSET_MINUTES,
  };
  if (!input.startDatetime || !input.endDatetime) throw new Error('Select a date range and run the report before exporting.');
  const res = await generateTrainingReportPDF(input);
  if (!res?.id) throw new Error('Failed to generate PDF. Please try again.');
  // check document status here
  while (true) {
    const [generatedDocument] = await searchGeneratedDocuments(res.id);
    if (generatedDocument?.status === GeneratedDocumentStatusEnum.Completed) {
      await downloadTrainingReportPDF(generatedDocument.fileLocation);
      break;
    }
    if (generatedDocument?.status === GeneratedDocumentStatusEnum.Failed) {
      throw new Error('Failed to generate PDF. Please try again.');
    }
    await sleep(1000); // wait 1 second before next poll
  }
};

export default generateTrainingReportPDF;
